import { builder } from '../../../../../../common/js/configs';
import { commonCreativeConfig } from '../common-creative-config';
import { commonBrand } from '../../common/common-brand';
import { commonUseCloseBtnSquared } from '../../common/common-close-btn';
import { commonArrowBtn } from '../../common/common-use-arrow-btn';
import { arrowPriorityOverBrand } from '../../common/brand-or-arrow-priority';
import { commonCta } from '../../common/common-cta';
import { commonUseBorderLayer } from '../../common/common-use-border-layer';

export const formatConfigUnmarshaller = {
  creative: builder.holder({
    ...commonCreativeConfig
  }),
  ...commonCta,
  ...commonUseCloseBtnSquared,
  ...commonArrowBtn,
  ...commonBrand,
  ...arrowPriorityOverBrand,
  ...commonUseBorderLayer
};
